import React from "react";
// import { useDispatch } from "react-redux";
import { Button } from "@chakra-ui/button";
// import { closeModal } from "../../app/common/modals/modalReducer";
import { useSelector } from "react-redux";
import { socialLogin } from "../../app/firestore/firebaseService";
import { ImTwitch, ImGoogle } from "react-icons/im";
import { HStack } from "@chakra-ui/layout";
import { useHistory } from "react-router";
import { useEffect } from "react";

export default function SocialLogin({ rest }) {
  const history = useHistory();
  const { prevLocation } = useSelector((state) => state.auth);
  const { currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    // If User is logged in successfully, forward to regular page
    const localPrevLocation = JSON.parse(localStorage.getItem("prevLocation"));

    if (currentUser?.uid) {
      if (history && prevLocation) {
        if (history.location.pathname !== prevLocation.pathname)
          history.push(prevLocation);
      } else if (localPrevLocation) {
        if (history.location.pathname !== localPrevLocation.pathname)
          history.push(localPrevLocation);
      } else {
        history.push("/settings");
      }
    }
  }, [history, prevLocation, currentUser]);

  function handleSocialLogin(provider) {
    socialLogin(provider);
  }

  return (
    <HStack justifyContent='center' {...rest}>
      <Button
        onClick={() => handleSocialLogin("google")}
        variant='google'
        leftIcon={<ImGoogle />}
      >
        Google
      </Button>
      <Button
        onClick={() => handleSocialLogin("twitch")}
        variant='twitch'
        leftIcon={<ImTwitch />}
      >
        Twitch
      </Button>
      {/* <Button
        onClick={() => handleSocialLogin("discord")}
        variant='discord'
        leftIcon={<RiDiscordFill />}
      >
        Discord
      </Button> */}
    </HStack>
  );
}
